<template>
    <div class="table table-bg">
    <div class="table-header center">
      <div class="table-tlt center-left">
        <h2>사용자 등록</h2>
      </div>
      <div class="table-btn center-right">
        <div>
          <button class="btn btn-140" @click="goList">사용자 리스트</button>
        </div>
      </div>
    </div>
    <div class="table-desc">
      <div class="table-content">
        <table>
          <tr>
            <td class="header">사용자 ID <font style="color:red;">*</font></td>
            <td><input type="text" v-model="user.userID" /></td>
          </tr>
          <tr>
            <td class="header">이메일 주소</td>
            <td><input type="text" v-model="user.email" /></td>
          </tr>
          <tr>
            <td class="header">역할 <font style="color:red;">*</font></td>
            <td>
              <select v-model="user.role">
                <option v-for="item in userRole" :key="item.code" :value="item.code">
                  {{ item.name }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="header">회사 이름</td>
            <td>{{ division.companyName }}</td>
          </tr>
        </table>
        <div class="vertical-line"></div>
        <table>
          <tr>
            <td class="header">사용자 이름</td>
            <td><input type="text" v-model="user.name" /></td>
          </tr>
          <tr>
            <td class="header">핸드폰 번호</td>
            <td><input type="text" v-model="user.mobile" /></td>
          </tr>
          <tr>
            <td class="header">비밀번호 <font style="color:red;">*</font></td>
            <td><input type="password" v-model="user.password" /></td>
          </tr>
          <tr>
            <td class="header">부서 이름</td>
            <td>{{ division.divisionName }}</td>
          </tr>
        </table>
      </div>
      <div class="table-btn center">
        <butto class="btn btn-140 btn-blue-line" @click="excuteUpdate">
          <span v-if="!processing" class="process">등록</span>
          <ButtonLoading v-else></ButtonLoading>
        </butto>
        <button
          class="btn btn-right"
          @click="cancelUpdate"
        >취소</button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable no-continue */

import Configuration from '@/js/Configuration';
import ButtonLoading from '@/components/include/ButtonLoading';

export default {
  props: [
    'division',
  ],
  components: {
    ButtonLoading,
  },
  data: () => ({
    userRole: [],
    user: {
      userID: null,
      name: null,
      passwd: null,
      password: null,
      role: null,
      mobile: null,
      email: null,
      //
      admin: null,
      manager: null,
      operator: null,
      monitor: null,
    },
    processing: false,
  }),
  created() {
    const token = this.$jwtDecode(this.$cookie.get('accessToken'));
    this.scope = token.scope;
    this.role = token.role;

    for (let i = 0; i < this.$userRole.length; i++) {
      if (this.$userRole[i].code === 4) {
        // monitor 는 CS 만 가능
        if (this.division.scope === 1 || this.division.scope === 2) {
          this.userRole.push(this.$userRole[i]);
        }
        continue;
      }

      if (i > 0) {
        this.userRole.push(this.$userRole[i]);
      } else if (i === 0 && this.scope === 1 && this.role === 1 && this.division.scope < 3) {
        this.userRole.push(this.$userRole[i]);
      }
    }
  },
  methods: {
    async excuteUpdate() {
      try {
        this.processing = true;
        if (!this.user.userID || this.user.userID === '') {
          alert('"사용자 ID"를 입력해 주세요');
          this.processing = false;
          return;
        } else if (!this.user.role) {
          alert('"역할"을 선택해 주세요');
          this.processing = false;
          return;
        } else if (!this.validPasswd(this.user.password)) {
          alert('"비밀번호"는 8자 이상~20자 이하로 입력해 주세요(숫자+영문 필수)');
          this.processing = false;
          return;
        }

        const url = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/user/register`;

        const encPass = this.$jsEncrypt.encrypt(this.user.password);
        this.user.passwd = encPass;

        this.user.admin = null;
        this.user.manager = null;
        this.user.operator = null;
        this.user.monitor = null;
        if (this.user.role === 1) {
          this.user.admin = {
            divisionID: this.division.divisionID,
          };
        } else if (this.user.role === 2) {
          this.user.manager = {
            divisionID: this.division.divisionID,
          };
        } else if (this.user.role === 3) {
          this.user.operator = {
            divisionID: this.division.divisionID,
          };
        } else if (this.user.role === 4) {
          this.user.monitor = {
            divisionID: this.division.divisionID,
          };
        } else {
          alert('"역할"이 올바르지 않습니다.');
          this.processing = false;
          return;
        }

        const param = this.user;

        const createResult = await this.$http.post(url,
          param,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          });
        if (createResult.status !== 200) {
          throw new Error(`Response status is "${createResult.status}"`);
        }
        if (createResult.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${createResult.data.resultCode}"`);
        }

        const division = {
          id: this.division.divisionID,
          name: this.division.divisionName,
          alias: this.division.divisionAlias,
          pID: this.division.companyID,
          pName: this.division.companyName,
          pAlias: this.division.companyAlias,
        };
        this.processing = false;
        this.$emit('refreshList', division, 'division', 1);
      } catch (e) {
        this.user.admin = null;
        this.user.manager = null;
        this.user.operator = null;
        this.user.monitor = null;
        if (e.response.status === 409) {
          alert('이미 존재하는 "사용자 ID"입니다.');
        } else if (e.response.status === 400) {
          if (e.response.data.resultCode === '1002') {
            alert('비밀번호는 "영문/숫자"가 포함되어야 합니다.');
          }
        }
        console.error(e);
        this.processing = false;
      }
    },
    cancelUpdate() {
      const division = {
        id: this.division.divisionID,
        name: this.division.divisionName,
        alias: this.division.divisionAlias,
        pID: this.division.companyID,
        pName: this.division.companyName,
        pAlias: this.division.companyAlias,
      };
      this.$emit('refreshList', division, 'division');
    },
    goList() {
      this.cancelUpdate();
    },
    validPasswd(pw) {
      const re = /(?=.*\d)(?=.*[a-zA-Z])^.{8,20}$/;
      return re.test(pw);
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/account/user/UserCreate.vue